import { FC, Fragment, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { MultiValue } from 'react-select';

import { Divider } from '@hsp/react-component-library';

import { VirtualSelect } from 'components/select';
import { useFetchClientTags } from 'pages/audience/shared/hooks/queries';
import { ISelectedFilter } from 'types/api/audience';
import { SearchType } from 'types/api/audience/enums';
import { ITag } from 'types/api/tag';
import { s } from 'utilities/strings';

const formName = `${SearchType.Tags}.clientTags`;

const ClientTags: FC = () => {
  const { data: clientTags, isFetching } = useFetchClientTags();
  const { getValues, setValue } = useFormContext();

  const getValue = useCallback(() => {
    const current = getValues(formName) as ISelectedFilter<ITag>;

    return current;
  }, [getValues]);

  const handleSelected = useCallback(
    (options: MultiValue<ITag>) => {
      const current = getValue();

      setValue(formName, { ...current, filters: options });
    },
    [getValue, setValue]
  );

  const getClientTagValue = useCallback(() => {
    const current = getValue();

    return clientTags?.filter((code) => (current?.filters ?? []).find((selected) => code.id === selected.id));
  }, [clientTags, getValue]);

  return (
    <Fragment>
      <div className="mb-3">
        <Divider>{s(['Site.Client', 'Site.Tag'], { plural: true })}</Divider>
      </div>
      <VirtualSelect
        closeMenuOnSelect={false}
        getOptionLabel={({ name }) => name}
        getOptionValue={({ id }) => id?.toString() ?? ''}
        isClearable
        isDisabled={isFetching}
        isLoading={isFetching}
        isMulti
        onChange={handleSelected}
        options={clientTags}
        placeholder={s('Site.Select')}
        value={getClientTagValue()}
      />
    </Fragment>
  );
};

export default ClientTags;
